import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../static/api';
import { QueryAliases } from '../../../types/QueryAliases';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

const useAcceptAnswer = ({ gameId }: { gameId: string }) => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    ({ answerId, points }: { answerId: number; points?: number }) =>
      axiosInstance.post(api.endpoints.ACCEPT_ANSWER({ answerId: answerId.toString() }), {
        ...(points !== undefined && { points }),
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries([QueryAliases.GAME_REVIEW_ANSWERS(gameId)]);
        queryClient.refetchQueries([QueryAliases.GAME_CHECKED_ANSWERS(gameId)]);
      },
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.acceptAnswerFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { acceptAnswer: mutateAsync, isLoading, isSuccess };
};

export default useAcceptAnswer;
